import util from './util'

let OutroNavigation = Vue.component('outro-nav', {
	props: ['items'],
	methods: {
		onClick: util.onClickOutroLink
	},
	computed: {
		fixedClass: function() {
			if (this.$root.$store.state.loopHelper.fixOutro) {
				return 'outro--fixed'
			} else {
				return ''
			}
		},
		dismissedClass: function() {
			if (this.$root.$store.state.loopHelper.dismissOutro) {
				return 'outro--dismissed'
			} else {
				return ''
			}
		},
		containerStyle: function() {
			this.$nextTick(() => {
				if (window.sashimi.isMobileWidth) {
					return {
						height: $(window).height() - this.$refs['outroMenu'].clientHeight + 'px'
					}
				} else {
					return {
						height: 'auto'
					}
				}
			})
		}
	},
	template: `
		<div class="outro-container" :style="containerStyle">
			<ul class="outro" v-bind:class="[fixedClass, dismissedClass]" ref="outroMenu">
				<li v-for="item in items">
					<a v-on:click="onClick" class="outro-link menu-link" :href="item.url" :data-id="item.ID" data-cursor="circle" data-type="page" :class="{ current: item.isCurrent }">{{ item.title }}</a>
				</li>
			</ul>
		</div>`
})

export default OutroNavigation
